// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretDownSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.16795 9.75193C7.56377 10.3457 8.43623 10.3457 8.83205 9.75192L10.9635 6.5547C11.4066 5.89014 10.9302 5 10.1315 5H5.86852C5.06982 5 4.59343 5.89015 5.03647 6.5547L7.16795 9.75193Z" />
    </svg>
  );
};
